// components/ChannelTalkController.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ChannelService from "./channel-talk";

const shouldShowChannel = (pathname: string) => pathname.startsWith("/form/apply/hipartner");

const ChannelTalkController: React.FC = () => {
  const { pathname, search } = useLocation();
  const pageSig = search ? `${pathname}${search}` : pathname;

  useEffect(() => {
    // 1) 페이지 컨텍스트 동기화
    ChannelService.setPage(pageSig);

    // 2) 노출 규칙: hipartner에서만 버튼 노출, 그 외는 완전 숨김
    if (shouldShowChannel(pathname)) {
      ChannelService.showChannelButton();
    } else {
      ChannelService.hideMessenger();
      ChannelService.hideChannelButton();
    }
  }, [pageSig, pathname]);

  return null;
};

export default ChannelTalkController;
